/**
 * Search-param contract for `/orca/runners`.
 *
 * A tiny pure module (no atoms, no design imports) so the eager `runners.tsx`
 * route file can `validateSearch` without pulling the orca-admin chunk into the
 * always-loaded graph. `?container=<id>` opens the container-logs drawer over
 * the Runners page; every other search value is ignored.
 *
 * @since 1.0.0
 */

/**
 * The validated `/orca/runners` search shape.
 *
 * @since 1.0.0
 */
export interface RunnersSearch {
  /** The container id whose logs drawer is open, or `undefined` when closed. */
  readonly container?: string | undefined;
}

/**
 * Coerce the raw search record into {@link RunnersSearch}: a string `container`
 * is kept verbatim, anything else (absent, number, object) resolves to
 * `undefined` (drawer closed).
 *
 * @since 1.0.0
 */
export const validateRunnersSearch = (search: Record<string, unknown>): RunnersSearch => ({
  container: typeof search.container === "string" ? search.container : undefined,
});
